import { ContractTrackings } from "@/@client/Theasoft_ApiServer_Contracts"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { DefaultListItem } from "@components/default-list/list-item"
import { useTranslation } from "react-i18next"
import { MantineColor, Text } from "@mantine/core"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { PersonNameWithUserNameFallback } from "@/routes/-components/chat/ChatListForCurrentUser/PersonNameWithUserNameFallback"
import {
  ContractTrackingIcon,
  ContractTrackingIconVariant,
} from "@/routes/app/contracts/approvals/-components/ContractTrackingTimeline/ContractTrackingIcon"
import { getDateOnly } from "@components/date-only"

interface Props {
  contractTrackings: ContractTrackings[]
  trackingStartIndex?: number
}

export function ContractTrackingCard({
  contractTrackings: contractTrackings,
  trackingStartIndex,
}: Props) {
  const { t } = useTranslation("app_server")

  const notCanceldTrackings = contractTrackings
    .flatMap((v) => v.trackings)
    .slice(trackingStartIndex)

  return (
    <DetailsCard title={"Tracking"}>
      {contractTrackings.map((contractTracking, groupIndex) => (
        <React.Fragment key={groupIndex}>
          <Text fz={"lg"} fw={"bold"}>
            {contractTracking.documentName}
          </Text>
          {contractTracking.trackings.map((tracking, trackingIndex) => {
            let iconVariant: ContractTrackingIconVariant = "default"
            let color: MantineColor | undefined = undefined
            const trackingCanceled =
              trackingStartIndex &&
              (trackingStartIndex === -1 ||
                contractTrackings
                  .flatMap((v) => v.trackings)
                  .indexOf(tracking) < trackingStartIndex)
            if (tracking.isDeadline) {
              iconVariant = "deadline"
              if (
                trackingCanceled ||
                notCanceldTrackings.indexOf(tracking) <
                  notCanceldTrackings.findLastIndex(
                    (v) =>
                      v.isDeadline &&
                      v.contractTrackingStatus.contractApprovalStatusId ===
                        tracking.contractTrackingStatus.contractApprovalStatusId
                  )
              ) {
                color = "gray"
              } else if (
                notCanceldTrackings.find(
                  (t) =>
                    !t.isDeadline &&
                    t.contractTrackingStatus.contractApprovalStatusId ===
                      tracking.contractTrackingStatus
                        .contractApprovalStatusId &&
                    t.trackingDate <= tracking.trackingDate
                )
              ) {
                color = "green"
              } else if (tracking.trackingDate <= getDateOnly()) {
                color = "red"
              }
            } else if (tracking.trackingDate) {
              iconVariant = trackingCanceled ? "canceled" : "done"
            }
            return (
              <>
                <DefaultListItem justify="start" w={"100%"} key={trackingIndex}>
                  <>
                    <ContractTrackingIcon
                      variant={iconVariant}
                      {...(color ? { color } : {})}
                    />
                    <PersonNameWithUserNameFallback userId={tracking.userId} />
                    <Text>{tracking.contractTrackingStatus.name}</Text>
                    <Text
                      ta={"end"}
                      style={{ alignSelf: "end", flex: 1 }}
                    >{`${tracking.trackingDate ? `${tracking.isDeadline ? `${t("Deadline")} ` : ""}${getFormattedDate(tracking.trackingDate)}` : ""}`}</Text>
                  </>
                </DefaultListItem>
                <Text ml={55} style={{ whiteSpace: "pre-wrap" }} c={"dimmed"}>
                  {tracking.note}
                </Text>
              </>
            )
          })}
        </React.Fragment>
      ))}
    </DetailsCard>
  )
}
